import Dialog from "./components/Dialog.vue";
import valid from "./directives/valid.js";

export function ui(app)
{
	app.component("UiDialog", Dialog);
	app.directive("valid", valid);
}

export * from "./composables/event.js";
export * from "./composables/http.js";
export * from "./composables/persist.js";
export * from "./composables/timer.js";
export * from "./composables/webSocket.js";
export * from "./modules/env.js";
